import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useEffect, useState } from 'react';
import { Box, DialogContent, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { updateFiscalReportCommentRequest } from 'redux/reducers/fiscalReports/reducer';
import {
	EReportType,
	EReportTypeDownload,
	getReportTypeDownload,
} from 'redux/reducers/fiscalReports/constants';
import { TEditCommentDialogProps } from './types';

export const EditCommentDialog: FC<TEditCommentDialogProps> = ({
	open,
	setClose,
	data,
	fiscalReportListRequestPayload,
}) => {
	const dispatch = useDispatch();
	const [comment, setComment] = useState<string>('');

	const reset = () => {
		setComment('');
	};

	const formik = useFormik({
		initialValues: {
			comment,
		},
		enableReinitialize: true,
		onSubmit: values => {
			if (!data) return;

			dispatch(
				updateFiscalReportCommentRequest({
					body: {
						data: {
							id: data.id,
							comment: values.comment,
						},
						tableName: `em_vat_report_generated_fiscal_${getReportTypeDownload(data.report_type)}`,
					},
					fiscalReportListRequest: fiscalReportListRequestPayload,
				}),
			);
			formik.resetForm();
			reset();
			setClose();
		},
	});

	useEffect(() => {
		if (!open) return;
		if (!data) return;

		setComment(data.comment || '');
	}, [data, open]);

	return (
		<Dialog
			open={open}
			sx={{
				'& .MuiDialog-paper': {
					width: '600px',
					maxWidth: '600px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary">Edit Comment</DialogTitle>
			<form onSubmit={formik.handleSubmit}>
				<DialogContent
					sx={{
						p: '0 12px 0px 12px',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: '16px',
						}}
					>
						<Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '4px' }}>
							{/* <Typography component="div" color="primary" sx={{ fontSize: '0.9rem' }}>
								Client: <b>{data?.client}</b>
							</Typography>
							<Typography component="div" color="primary" sx={{ fontSize: '0.9rem' }}>
								Report Period:{' '}
								<b>
									{data?.report_period_name} {data?.year}
								</b>
							</Typography>
							<Typography component="div" color="primary" sx={{ fontSize: '0.9rem' }}>
								Report Type: <b>{data?.report_type}</b>
							</Typography>
							<Typography component="div" color="primary" sx={{ fontSize: '0.9rem' }}>
								Comment: <b>{formik.values.comment}</b>
							</Typography> */}

							<TextField
								id="comment"
								name="comment"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Comment"
								value={formik.values.comment}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
								multiline
								rows={3}
								fullWidth
								error={formik.touched.comment && Boolean(formik.errors.comment)}
								helperText={formik.touched.comment && formik.errors.comment}
							/>
						</Box>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							formik.resetForm();
							reset();
							setClose();
						}}
					>
						Cancel
					</Button>
					<Button type="submit" autoFocus disabled={!formik.values.comment}>
						Save
					</Button>
				</DialogActions>
			</form>
		</Dialog>
	);
};
